module.exports = function() {
  return m.stream(...arguments);
}